import React, { useCallback, useEffect, useState } from 'react';
import { useQuery } from '@apollo/client';
import ThirdPane from '../ThirdPane';
import ThirdPaneContent from '../ThirdPane/ThirdPaneContent';
import ThirdPaneHeader from '../ThirdPane/ThirdPaneHeader';
import JobHistory from '../Job/JobHistory';
import { Flex } from 'rebass';
import useNotify from '../../hooks/useNotify';
import HazardSurveyDetail from './HazardSurveyDetail';
import Button from '../Button/Button';
import { PortalWithState } from 'react-portal';
// import HazardSurveySchedulingModal from './HazardSurveySchedulingModal';
// import HazardSurveyResultsModal from './HazardSurveyResultsModal';
import HazardSurveyUpdateModal from './HazardSurveyUpdateModal';
import { GET_HAZARD_SURVEY_JOB } from './queries';
import HazardSurveyResultsModal from './HazardSurveyResultsModal';
import { ResultOf } from 'gql.tada';
import { useHistory } from 'react-router-dom';
import useMode from '../../hooks/useMode';

type HazardSurveyThirdPaneProps = {
  jobId?: string;
  prevEnabled: boolean;
  nextEnabled: boolean;
  onPrev?: () => void;
  onNext?: () => void;
  onToggle?: (visible: boolean) => void;
  reload?: () => void;
};

// const downloadPdf = (jobId?: string) => {
//   if (!jobId) {
//     return
//   }
//   const url = `${config.apiBase}/test-reports/${jobId}?token=${getToken()}`
//   window.open(url)
// }

export type JobWithHazardSurvey = ResultOf<
  typeof GET_HAZARD_SURVEY_JOB
>['jobs'][number];

export default function HazardSurveyThirdPane({
  jobId,
  reload,
  onPrev,
  onNext,
  onToggle,
  prevEnabled,
  nextEnabled,
}: HazardSurveyThirdPaneProps): JSX.Element {
  const mode = useMode();
  const history = useHistory();
  const {
    loading: itemLoading,
    error: itemError,
    data: itemData,
    refetch,
  } = useQuery(GET_HAZARD_SURVEY_JOB, {
    skip: !jobId,
    variables: { where: { id: jobId } },
  });

  const advanceAndReload = useCallback(() => {
    if (onNext && nextEnabled) {
      onNext();
    }
    if (reload) {
      reload();
    }
  }, [onNext, nextEnabled]);

  const { showError } = useNotify();

  const [job, setJob] = useState<JobWithHazardSurvey>();

  useEffect(() => {
    if (itemData && itemData?.jobs?.length) {
      setJob(itemData?.jobs[0] as JobWithHazardSurvey);
    }
  }, [jobId, itemData, setJob]);

  const downloadReport = useCallback(() => {
    if (job) {
      // downloadPdf(jobId)
    }
  }, [job?.id]);

  if (itemError) {
    throw itemError;
  }

  return (
    <ThirdPane visible={!!jobId}>
      <ThirdPaneHeader
        onToggle={onToggle}
        title={job ? job?.id : 'Loading...'}
        onPrev={onPrev}
        onNext={onNext}
        prevEnabled={prevEnabled}
        nextEnabled={nextEnabled}
      >
        {job && (
          <>
            <Button
              mr={10}
              icon="edit"
              variant="outline"
              onClick={() =>
                history.push(`/${mode}/hazard-surveys/${jobId}/edit`)
              }
            >
              Edit form
            </Button>
            <PortalWithState closeOnEsc>
              {({ openPortal, closePortal, portal }) => (
                <>
                  <Button variant="outline" onClick={openPortal}>
                    Enter Results
                  </Button>
                  {portal(
                    <HazardSurveyResultsModal
                      key={job.id}
                      jobId={job.id}
                      onClose={closePortal}
                    />
                  )}
                </>
              )}
            </PortalWithState>
          </>
        )}
      </ThirdPaneHeader>
      <ThirdPaneContent>
        {job && (
          <>
            <Flex height="100%" flexDirection="row" flexGrow={1} flexShrink={1}>
              <Flex
                flexDirection="column"
                flexGrow={1}
                flexShrink={1}
                height="100%"
                width="50%"
                overflowY="scroll"
              >
                {job?.waterHazardSurvey && (
                  <HazardSurveyDetail job={job} onChange={refetch} />
                )}
              </Flex>
              <Flex
                flexDirection="column"
                flexGrow={1}
                flexShrink={1}
                height="100%"
                width="50%"
                sx={{ borderLeft: '1px solid', borderLeftColor: 'tableBorder' }}
              >
                <JobHistory
                  jobId={job.id}
                  comments={job.comments}
                  statusChanges={job.statusChanges}
                  attachments={job.attachments}
                  refetch={refetch}
                />
              </Flex>
            </Flex>
          </>
        )}
      </ThirdPaneContent>
      {/*{false && (*/}
      {/*  <ThirdPaneFooter>*/}
      {/*    <Box flexGrow={1} textAlign="right">*/}
      {/*      <Button onClick={downloadReport} icon="file-download" variant="secondary">*/}
      {/*        PDF*/}
      {/*      </Button>*/}
      {/*    </Box>*/}
      {/*  </ThirdPaneFooter>*/}
      {/*)}*/}
    </ThirdPane>
  );
}
